import { BookmarkCircle } from './Bookmark.styles';
import { BookmarkCirclePositions } from './Bookmark.helpers';

/**
 * Description placeholder
 *
 * @param {Object} param
 * @param {string} param.dataId
 * @param {boolean} param.animate
 * @param {string} param.color
 * @returns {React.ReactElement}
 */
const BookmarkCircles = ({ dataId, animate, color }) => (
  <>
    {Object.entries(BookmarkCirclePositions).map(([key, elementBounds]) => (
      <BookmarkCircle
        key={key}
        data-id={`${dataId}-heart-circle-${key.toLowerCase()}`}
        $size={elementBounds.size}
        $coordinates={elementBounds.coordinates}
        $animate={animate}
        $color={color}
      />
    ))}
  </>
);

export default BookmarkCircles;
